// JavaScript entrypoint
//
// Load order matters:
//   1. Rails/Hotwire — must be first so Turbo intercepts links before jQuery
//   2. jQuery — exposed on window so inline <script> tags in views can use $
//   3. UI framework libs — Bootstrap, FontAwesome
//      (FullCalendar imported in fullcalendar_setup.js — must stay before the CSS
//      entrypoint so its runtime injectStyles() fires before our overrides)
//   4. App modules — initialize plugins and behavior on each Turbo page load
//   5. CSS entrypoint — imported last so all plugin CSS is already injected

// Rails & Hotwire
import "@rails/actiontext";
import { start as startActiveStorage } from "@rails/activestorage";
import { Turbo } from "@hotwired/turbo-rails";
import "../channels";
startActiveStorage();

// Rich text
import "trix";

// jQuery — must be on window for inline <script> tags in views
import $ from "jquery";
window.$ = window.jQuery = $;

// UI frameworks
import "bootstrap";
import "@fortawesome/fontawesome-free/js/all.min";
import Highcharts from "highcharts";
window.Highcharts = Highcharts;

// App modules
/// Plugins
import "../app/fullcalendar_setup";
import "../app/tabs";
import "../app/tom_select";
/// Search
import "../app/auto_search";
import "../app/job_search";
import "../app/list_search";
/// Other
import "../app/form_validation";
import "../app/inline_actions";
import "../app/nav";
import "../app/public_pages";

// CSS entrypoint (imported after UI frameworks so our overrides win)
import "./application.scss";
